import React, { useState, useCallback } from 'react'
import { Helmet } from 'react-helmet-async'
import { AdminXsMenu } from '../../component/admin/AdminXsMenu'
import { Box, Typography, Button, TextField } from '@mui/material'
import { Navbar } from '../../component/shared/Navbar'
import AddIcon from '@mui/icons-material/Add'
import Table from './Table'
import { debounce } from 'lodash'
import { PageContainer } from '../../component/styled/PageContainer'

export const HtgIncentiveAdminScreen = () => {
  const [open, setOpen] = useState(false)
  const [searchKey, setSearchKey] = useState('')

  const handleSearch = useCallback(
    debounce((value) => setSearchKey(value), 500),
    [],
  )

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>HTG Incentive Admin</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Box display='flex' my={3} justifyContent='space-between'>
          <Typography variant='h1'>HTG Incentive Admin</Typography>
          <AdminXsMenu />
        </Box>
        <Box gap={2} display='flex' mb={3}>
          <TextField
            label='Search'
            variant='outlined'
            onChange={(e) => handleSearch(e.target.value)}
            placeholder='Name / ID'
            fullWidth
          />
          <Button
            startIcon={<AddIcon style={{ color: 'white' }} />}
            variant='contained'
            color='primary'
            onClick={() => setOpen(true)}
          >
            Create
          </Button>
        </Box>
        <Table open={open} setOpen={setOpen} searchKey={searchKey} isEdit={false} />
      </PageContainer>
    </>
  )
}
